export default "/assets/images/chart-02.0d67fa6253da6f00.svg";